export default class Service {
  options: Record<string, unknown>;

  constructor(options: Record<string, unknown> = {}) {
    this.options = options;
  }

  static build(options: Record<string, unknown> = {}) {
    return new this(options);
  }
}
